
interface Specification {
  label: string;
  value: string;
}

interface ProductSpecificationsProps {
  specifications: Specification[];
}

export default function ProductSpecifications({ specifications }: ProductSpecificationsProps) {
  return (
    <section className="py-16 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-bold text-gray-900 mb-4">
            Technical Specifications
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            Detailed technical information and performance characteristics of our dry chemical extinguishers.
          </p>
        </div>

        <div className="bg-white rounded-2xl shadow-xl overflow-hidden">
          <div className="bg-gradient-to-r from-red-600 to-red-700 px-8 py-6">
            <h3 className="text-xl font-semibold text-white flex items-center">
              <i className="ri-file-list-3-line mr-3"></i>
              Product Specifications
            </h3>
          </div>
          
          <div className="p-8">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-x-12 gap-y-6">
              {specifications.map((spec, index) => (
                <div 
                  key={index}
                  className="flex justify-between items-center py-3 border-b border-gray-100 last:border-b-0"
                >
                  <span className="text-gray-600 font-medium">{spec.label}:</span>
                  <span className="text-gray-900 font-semibold text-right">{spec.value}</span>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Performance Chart */}
        <div className="mt-12 grid grid-cols-1 md:grid-cols-3 gap-8">
          <div className="bg-white rounded-xl p-6 shadow-lg text-center">
            <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4">
              <i className="ri-time-line text-blue-600 text-2xl"></i>
            </div>
            <h4 className="text-lg font-semibold text-gray-900 mb-2">Discharge Time</h4>
            <p className="text-3xl font-bold text-blue-600 mb-1">15-25</p>
            <p className="text-gray-600">seconds</p>
          </div>
          
          <div className="bg-white rounded-xl p-6 shadow-lg text-center">
            <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
              <i className="ri-focus-3-line text-green-600 text-2xl"></i>
            </div>
            <h4 className="text-lg font-semibold text-gray-900 mb-2">Effective Range</h4>
            <p className="text-3xl font-bold text-green-600 mb-1">3-5</p>
            <p className="text-gray-600">meters</p>
          </div>
          
          <div className="bg-white rounded-xl p-6 shadow-lg text-center">
            <div className="w-16 h-16 bg-purple-100 rounded-full flex items-center justify-center mx-auto mb-4">
              <i className="ri-temp-cold-line text-purple-600 text-2xl"></i>
            </div>
            <h4 className="text-lg font-semibold text-gray-900 mb-2">Operating Range</h4>
            <p className="text-3xl font-bold text-purple-600 mb-1">-30°C to +60°C</p>
            <p className="text-gray-600">temperature</p>
          </div>
        </div>
      </div>
    </section>
  );
}
